import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchClientListResponse>}
 */
export function requestClientList(params) {
  return fetch.get(`${BASE_URL}/api/app/client/getClientLeadGen`, {
    params: { limit: Number.MAX_SAFE_INTEGER },
  });
}

export function requestTdsList(params) {
  return fetch.get(`${BASE_URL}/api/app/client/getAllAccounts`, {
    params: { limit: Number.MAX_SAFE_INTEGER },
  });
}
export function requestClientFilterList(params) {
  return fetch.get(`${BASE_URL}/api/app/client/getClientByFilter`, {
    params: { limit: Number.MAX_SAFE_INTEGER },
  });
}
export function requestCreateClient(data) {
  return fetch.post(`${BASE_URL}/api/app/client`, data);
}
export function requestUpdateClient(data) {
  console.log("sharfe", data);
  const body = { ...data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/client/${data._id}`, body);
}

export function requestDeleteClient(data) {
  const body = {
    accId: data,
  };
  return fetch.put(
    `${BASE_URL}/api/app/client/updateAccountTds/removeSingle`,
    body
  );
}

export function requestAllDeleteClient() {
  return fetch.put(
    `${BASE_URL}/api/app/client/updateAccountTds/removeAll`,
  );
}
export function uploadExcelData(data) {
  return fetch.post(`${BASE_URL}/api/app/client/updateTdsByExcel`, data);
}

export function requestClientAgreementDetails(params) {
  // console.log(params);
  if (params !== undefined) {
    return fetch.get(
      `${BASE_URL}/api/app/agreement/getClientAgreements/${params}`
    );
  }
}
